var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('FontAwesomeIcon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.label),expression:"label"}],attrs:{"icon":['fal', _vm.icon]}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }